import { all, fork } from 'redux-saga/effects';
import loadAuthSaga from './auth.saga';
import loadCompanySaga from './company.saga';
import loadJobRoles from './Interviews/jobRoles.saga';
import loadCandidates from './Interviews/candidates.saga';
import loadInterviewersSaga from './Interviews/interviewers.saga';
import loadInterviewProblemLibrarySaga from './Interviews/problemLibrary.saga';
import loadInterviewTechnologiesSaga from './Interviews/technologies.saga';
import loadAiInterviewsSaga from './AiInterviews/aiInterviews.saga';
import loadRolesSaga from './RecruiterDashboard/roles.saga';
import loadRecruiterSaga from './RecruiterDashboard/recruiter.saga';
import loadBackofficeSaga from './RecruiterDashboard/backoffice.saga';
import loadDhwaniDashboardSaga from './dhwani/campaings.saga';
import loadCampaignSaga from './dhwani/campaign.saga';
import loadCocallerAppSettingsSaga from './dhwani/cocallerAppSettings.saga';
import ledgerDetailsSaga from './ledgerDetails.saga';

export default function* rootSaga() {
  yield all([fork(loadAuthSaga)]);
  yield all([fork(loadCompanySaga)]);
  yield all([fork(loadJobRoles)]);
  yield all([fork(loadCandidates)]);
  yield all([fork(loadInterviewersSaga)]);
  yield all([fork(loadInterviewProblemLibrarySaga)]);
  yield all([fork(loadInterviewTechnologiesSaga)]);
  yield all([fork(loadAiInterviewsSaga)]);
  yield all([fork(loadRolesSaga)]);
  yield all([fork(loadRecruiterSaga)]);
  yield all([fork(loadBackofficeSaga)]);
  yield all([fork(loadDhwaniDashboardSaga)]);
  yield all([fork(loadCampaignSaga)]);
  yield all([fork(loadCocallerAppSettingsSaga)]);
  yield all([fork(ledgerDetailsSaga)]);
}
